import React from 'react';
import { Box } from '@mui/material';

/** Drag strip + always-visible separator for primary (blue) MUI table headers — aligned with `TanStackDataTable`. */
const MuiTablePrimaryHeaderResizeArea: React.FC<{
  columnId: string;
  onBeginResize: (columnId: string, e: React.MouseEvent | React.TouchEvent) => void;
  isResizing: boolean;
}> = ({ columnId, onBeginResize, isResizing }) => (
  <Box
    onMouseDown={(e) => onBeginResize(columnId, e)}
    onTouchStart={(e) => onBeginResize(columnId, e)}
    role="separator"
    aria-orientation="vertical"
    aria-label={`Resize ${columnId}`}
    sx={{
      position: 'absolute',
      right: 0,
      top: 0,
      height: '100%',
      // Wider invisible hit-area so the thin visual line is still easy to grab.
      width: 8,
      cursor: 'col-resize',
      userSelect: 'none',
      touchAction: 'none',
      zIndex: 2,
      backgroundColor: 'transparent',
      // Thin vertical separator pinned to the right edge — looks like a column border.
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        width: '1px',
        backgroundColor: isResizing ? '#fff' : 'rgba(255,255,255,0.35)',
        pointerEvents: 'none',
        transition: 'background-color 120ms ease',
      },
      '&:hover::after': {
        backgroundColor: '#fff',
      },
    }}
  />
);

export default MuiTablePrimaryHeaderResizeArea;
